import React, { memo } from 'react';
import { ItemMaster } from '../../../../../../../services/apiTypes';
import {
  Box,
  TableCell,
  IconButton,
  Checkbox,
  Typography,
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  DragHandle,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from '@mui/icons-material';
import { manageItemStyle } from '../../../../InspectionItemTable';
import {
  INSPECTION_DISPLAY_TYPE,
  MANAGE_ITEM_MODE,
} from '../../../../../../../_constants/manageConst';

type DisplayDepth1RowProps = {
  item: ItemMaster;
  mode: number;
  isAdmin: boolean;
  stickyPosition: number[];
  countItems: number;
  isOpenAccordion: boolean;
  displayType: number;
  onClickAccordion: (id: string) => void;
  onClickAddIcon: (data: ItemMaster) => void;
  onClickEditIcon: (data: ItemMaster) => void;
  onClickDeleteIcon: (data: ItemMaster) => void;
};

const DisplayDepth1RowComponent: React.FC<DisplayDepth1RowProps> = ({
  item,
  mode,
  isAdmin,
  stickyPosition,
  countItems,
  isOpenAccordion,
  displayType,
  onClickAccordion,
  onClickAddIcon,
  onClickEditIcon,
  onClickDeleteIcon,
}) => {
  return (
    <React.Fragment>
      <TableCell
        sx={[
          manageItemStyle.iconCellCenter,
          manageItemStyle.leftSideSticky,
          { left: stickyPosition[3], verticalAlign: 'top' },
        ]}
        rowSpan={isOpenAccordion ? countItems + 1 : 1}
      >
        {mode === MANAGE_ITEM_MODE.SORT && (
          <IconButton size="small" sx={{ cursor: 'grab', touchAction: 'none' }}>
            <DragHandle fontSize="small" />
          </IconButton>
        )}
      </TableCell>
      <TableCell
        sx={[
          manageItemStyle.leftSideSticky,
          { left: stickyPosition[4], p: 0, whiteSpace: 'nowrap' },
        ]}
        colSpan={2}
      >
        <Box sx={manageItemStyle.nameBox}>
          {!!countItems ? (
            <IconButton
              size="small"
              onClick={() => onClickAccordion(item.itemId)}
              onPointerDown={(e) => e.stopPropagation()}
              sx={manageItemStyle.iconCellCenter}
            >
              {isOpenAccordion ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
            </IconButton>
          ) : (
            <Box sx={manageItemStyle.emptyBox} />
          )}
          <Typography sx={manageItemStyle.nameTypography}>
            {item.displayName}
          </Typography>
        </Box>
      </TableCell>
      {isAdmin && (
        <TableCell sx={manageItemStyle.iconCellCenter}>
          <Checkbox
            name="isOptionalAddition"
            disabled
            checked={item.isOptionalAddition}
            sx={{ py: '2px' }}
          />
        </TableCell>
      )}
      <TableCell />
      <TableCell sx={{ py: 0, textAlign: 'center' }}>{item.pCode}</TableCell>
      <TableCell sx={{ py: 0, textAlign: 'center' }}>{item.fCode}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.rCodeList.join(', ')}</TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute1.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute2.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute3.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute5.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute6.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedBrandName.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0, textAlign: 'center' }}>
        {item.selectedConditions}
      </TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.text}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.max}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.min}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.memo}</TableCell>
      {mode === MANAGE_ITEM_MODE.VIEW ? (
        <React.Fragment>
          <TableCell
            sx={[manageItemStyle.icon1Sticky, manageItemStyle.iconCellCenter]}
          >
            {!(displayType === INSPECTION_DISPLAY_TYPE.STANDARD.value) && (
              <IconButton
                size="small"
                sx={manageItemStyle.iconCellCenter}
                onClick={() => onClickAddIcon(item)}
                onPointerDown={(e) => e.stopPropagation()}
              >
                <Add fontSize="small" color="primary" />
              </IconButton>
            )}
          </TableCell>
          <TableCell
            sx={[manageItemStyle.icon2Sticky, manageItemStyle.iconCellCenter]}
          >
            {(isAdmin || item.isOptionalAddition) && (
              <IconButton
                size="small"
                sx={manageItemStyle.iconCellCenter}
                onClick={() => {
                  onClickEditIcon(item);
                }}
                onPointerDown={(e) => e.stopPropagation()}
              >
                <Edit fontSize="small" />
              </IconButton>
            )}
          </TableCell>
          <TableCell
            sx={[manageItemStyle.icon3Sticky, manageItemStyle.iconCellCenter]}
          >
            {/* 子項目がなければ削除アイコンを表示する */}
            {!countItems && (isAdmin || item.isOptionalAddition) && (
              <IconButton
                size="small"
                sx={manageItemStyle.iconCellCenter}
                onClick={() => {
                  onClickDeleteIcon(item);
                }}
                onPointerDown={(e) => e.stopPropagation()}
              >
                <Delete fontSize="small" color="error" />
              </IconButton>
            )}
          </TableCell>
        </React.Fragment>
      ) : (
        <TableCell colSpan={3} />
      )}
    </React.Fragment>
  );
};

export const DisplayDepth1Row = memo(DisplayDepth1RowComponent);
